import React from 'react';

import { FormWrapper } from 'components/modules/Insurance/components/FormWrapper/FormWrapper';

import { DEFAULT_OUTPUT_DATE_FORMAT } from '../../VehicleInformation.constants';

import { usePtsInformationPresenter } from './PtsInformation.presenter';
import * as S from './PtsInformation.styles';

export const PtsInformation = () => {
  const presenter = usePtsInformationPresenter();

  return (
    <FormWrapper>
      <S.PtsNumberInput
        disabled={presenter.disabled}
        error={presenter.numberError}
        value={presenter.number}
        onChange={presenter.onChangeCarInstanceValue}
      />
      <S.PtsIssueDatepicker
        disabled={presenter.disabled}
        error={presenter.issueDateError}
        outputFormat={DEFAULT_OUTPUT_DATE_FORMAT}
        value={presenter.issueDate}
        onChange={presenter.onChangeCarInstanceValue}
      />
      <S.MarkAsPTSInput
        disabled={presenter.disabled}
        error={presenter.markAsPTSError}
        value={presenter.markAsPTS}
        onChange={presenter.onChangeMarkAsPTS}
      />
      <S.ModelAsPTSInput
        disabled={presenter.disabled}
        error={presenter.modelAsPTSError}
        value={presenter.modelAsPTS}
        onChange={presenter.onChangeModelAsPTS}
      />
    </FormWrapper>
  );
};
